import "./Disclaimer.css"

const Disclaimer = ({ disclaimers }) => {
  const defaultDisclaimers = [
    "This is not a diagnostic tool and it does not guarantee the accuracy of the result and cannot be independently acted upon.",
    "This Risk score and Clinical Algorithm is a general guideline for Physicians. Any additional laboratory investigations, Diagnostic Imaging, Treatment or Patient Education related to lifestyle management is under Physician's or Cardiologist's discretion.",
    "To ensure the information in the report is up to date, accurate, and correct, the Doctor shall be consulted to interpret the report.",
    "Apollo Hospitals and its Staff does not offer any assurance on the information made available or be liable for any loss or damage as the said report is based on the AICVD Cardiac Risk Score without any intervention from their side.",
    "By usage of this AICVD Cardiac Risk Score, it is deemed that the beneficiary of this service has agreed to get the same done at his own risk and further agrees with this disclaimer without any limitation or any clauses or sub-clauses.",
  ]

  const itemsToShow = disclaimers && disclaimers.length > 0 ? disclaimers : defaultDisclaimers

  return (
    <div className="disclaimer-container">
      <ul className="disclaimer-list">
        {itemsToShow.map((item, index) => (
          <li key={index} className="disclaimer-item">
            {item}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Disclaimer

